import React from "react";
import classes from "../../ARC_Reconciliation/Sales/GST-1_Reconciliation/GSTReconciliation.module.css";


const RCMLedgerTable = ({ data }) => {
    const formatCurrency = (value) => value ? `₹${value.toLocaleString("en-IN")}` : "-";

    return (
        <div
            className="responsive-table"
            style={{ scrollbarWidth: "thin", scrollbarHeight: '25px', maxHeight: '63vh' }}
        >
            <table className={classes.AllInvoiceReconTableCss}>
                <thead>
                    <tr>
                        <th rowSpan={2} style={{ width: '1%' }}>Date</th>
                        <th rowSpan={2} style={{ width: '2%' }}>Reference No</th>
                        <th rowSpan={2} style={{ width: '2%' }}>Return Period
                        </th>
                        <th rowSpan={2} style={{ width: '2%' }}>Description</th>
                        <th colSpan={5} style={{ width: '5%' }}>Liability Paid Inward supplies (liable to reverse charge)(Table 3.1(d)) (₹)</th>
                        <th colSpan={3} style={{ width: '5%' }}>ITC Claimed Import of services (Table 4A(2)) (₹)		
                        </th>
                        <th colSpan={5} style={{ width: '5%' }}>ITC Claimed Inward supplies liable to reverse charge other than import (Table 4A(3)) (₹)				
                        </th>
                        <th colSpan={5} style={{ width: '5%' }}>Closing Balance (₹) 'Opening Balance +  Liability 3.1(d) - ITC Claimed 4A(2) - ITC Claimed 4A(3)'				
                        </th>
                    </tr>
                    <tr>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Integrated Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Central Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>State/UT Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Cess</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Total</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Integrated Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Cess</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Total</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Integrated Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Central Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>State/UT Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Cess</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Total</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Integrated Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Central Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>State/UT Tax</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Cess</th>
                        <th style={{ whiteSpace: 'nowrap', position: 'sticky', top: '40px', zIndex: 9 }}>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data.length > 0 ? (
                        data.map((row, index) => (
                            <tr key={index} style={{ height: '45px' }}>
                                <td>{row.transaction_date || "-"}</td>
                                <td>{row.reference_no || "-"}</td>
                                <td>{row.return_period || "-"}</td>
                                <td>{row.description || "-"}</td>
                                <td>{formatCurrency(row.inwardsup_3_1d?.igst)}</td>
                                <td>{formatCurrency(row.inwardsup_3_1d?.cgst)}</td>
                                <td>{formatCurrency(row.inwardsup_3_1d?.sgst)}</td>
                                <td>{formatCurrency(row.inwardsup_3_1d?.cess)}</td>
                                <td>{formatCurrency(row.inwardsup_3_1d?.total)}</td>

                                {/* itc4a2 - ITC Reversal columns */}
                                <td>{formatCurrency(row.itc4a2?.igst)}</td>
                                <td>{formatCurrency(row.itc4a2?.cess)}</td>
                                <td>{formatCurrency(row.itc4a2?.total)}</td>

                                {/* itc4a3 - ITC Reclaimed columns */}
                                <td>{formatCurrency(row.itc4a3?.igst)}</td>
                                <td>{formatCurrency(row.itc4a3?.cgst)}</td>
                                <td>{formatCurrency(row.itc4a3?.sgst)}</td>
                                <td>{formatCurrency(row.itc4a3?.cess)}</td>
                                <td>{formatCurrency(row.itc4a3?.total)}</td>

                                {/* Closing Balance columns - would need calculation logic */}
                                <td>{formatCurrency(row.clsbal?.igst)}</td>
                                <td>{formatCurrency(row.clsbal?.cgst)}</td>
                                <td>{formatCurrency(row.clsbal?.sgst)}</td>
                                <td>{formatCurrency(row.clsbal?.cess)}</td>
                                <td>{formatCurrency(row.clsbal?.total)}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={50} style={{ textAlign: "center", fontWeight: "bold" }}>Loading… Please wait</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default RCMLedgerTable;
